/** Matches readonly stop value height (`h-7` / 28px) inside {@link STOP_ROW_HEIGHT_PX} rows. */
export const PALETTE_STOP_NUMBER_INPUT_HEIGHT_PX = 28;

/** Shared class for palette stop `modus-wc-number-input` hosts (spinner hiding + compact height). */
export const PALETTE_STOP_NUMBER_INPUT_CLASS = 'palette-stop-number-input';

export const PALETTE_STOP_NUMBER_INPUT_SPINNER_HIDE_CSS = `
  .${PALETTE_STOP_NUMBER_INPUT_CLASS} {
    display: block;
    box-sizing: border-box;
    height: ${String(PALETTE_STOP_NUMBER_INPUT_HEIGHT_PX)}px;
    max-height: ${String(PALETTE_STOP_NUMBER_INPUT_HEIGHT_PX)}px;
    min-height: 0;
    overflow: hidden;
  }

  .${PALETTE_STOP_NUMBER_INPUT_CLASS} .modus-wc-input,
  .${PALETTE_STOP_NUMBER_INPUT_CLASS} modus-wc-input {
    margin-bottom: 0 !important;
    min-height: 0 !important;
    height: 100% !important;
    max-height: 100% !important;
  }

  .${PALETTE_STOP_NUMBER_INPUT_CLASS} input[type='number']::-webkit-outer-spin-button,
  .${PALETTE_STOP_NUMBER_INPUT_CLASS} input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .${PALETTE_STOP_NUMBER_INPUT_CLASS} input[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
    box-sizing: border-box;
    height: ${String(PALETTE_STOP_NUMBER_INPUT_HEIGHT_PX)}px !important;
    min-height: 0 !important;
    max-height: ${String(PALETTE_STOP_NUMBER_INPUT_HEIGHT_PX)}px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    line-height: ${String(PALETTE_STOP_NUMBER_INPUT_HEIGHT_PX)}px !important;
    font-size: 0.875rem;
  }
`;
